module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mobile-a36568a0dd33ed0ce2c339a6b4fa9aaf.jpg";